export const DOCUMENT_MASK = Object.freeze({
  CPF: '###.###.###-##',
  CNPJ: '##.###.###/####-##',
});

export const DOCUMENT_LENGTH_WITH_MASK = Object.freeze({
  CPF: 14,
  CNPJ: 18,
});
